import { IUpdateIndiceReajusteUseCase } from "../../../presentation/useCases/update/update_indice_reajuste_use_case";
import { IndiceReajuste } from "../../models/indice_reajuste";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateIndiceReajusteUseCase
 */

export class UpdateIndiceReajusteUseCase implements IUpdateIndiceReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updateIndiceReajuste(form: IndiceReajuste): Promise<void> {
    await this.repository.updateIndiceReajuste(form);

  }
}
